export default "/public/app-main/static/image/7f4e069c19496fc0ac4f7fad6f6de09a.png";